@if (progressState.isLoading) {
  <div class="global-progress-container">
    <div class="progress-bar-wrapper">
      <mat-progress-bar
        [mode]="progressState.isColdStart ? 'indeterminate' : 'determinate'"
        [value]="progressState.progress"
        class="progress-bar"
      ></mat-progress-bar>
    </div>
    <div class="progress-message">
      @if (progressState.isColdStart) {
        <mat-icon class="cold-start-icon">cloud_sync</mat-icon>
      }
      <span>{{ progressState.message }}</span>
    </div>
  </div>
}
